import * as React from 'react';

export class CookieList extends React.Component {

    public render() {
        return (
            <div>
                <div id="ot-sdk-cookie-policy"></div>
            </div>
        );
    }
}